import React from "react";
import CurrencyCard from "./GeneralCards/CurrencyCard";
import GameData from "../../gameplay/model/GameData";
import cash_icon from "../../images/gameplay_ui/icons/bottom_panel/cash.svg"
import debet_icon from "../../images/gameplay_ui/icons/bottom_panel/debet.svg"
import credit_icon from "../../images/gameplay_ui/icons/bottom_panel/credit.svg"
import creditors_icon from "../../images/gameplay_ui/icons/bottom_panel/creditors.svg"
import assets_icon from "../../images/gameplay_ui/icons/bottom_panel/assets.svg"
import exp_icon from "../../images/gameplay_ui/icons/bottom_panel/exp.svg"
import nsp_icon from "../../images/gameplay_ui/icons/bottom_panel/nsp.svg"
import statistic from "../../images/gameplay_ui/icons/bottom_panel/statistic.svg"
import gainsLosses from "../../images/gameplay_ui/icons/bottom_panel/gainsLosses.svg";
import GameButtonWithIcon from "./GameButtonWithIcon";
import GameButtonWithText from "./GameButtonWithText";
import UtilsFunctions from "../../utils/UtilsFunctions";
import CreditPopup from "./Popups/CreditPopup";

export default class GameBottomPanel extends React.Component {
    constructor(props) {
        super(props);
        this.popup = null;
    }

    render() {
        let mainStyle = {
            background: "rgba(0, 0, 0, 0.65)",
            display: "flex",
            width: `${this.props.width}px`,
            height: "60px",
            justifyContent: "start",
            alignItems: "center",
            backdropFilter: "blur(10px)"
        }
        let paddingStyle = {
            paddingLeft: "20px",
            paddingRight: "10px"
        }
        let currencyStyle = {
            minWidth: "100px",
            ...paddingStyle
        }
        let pushStyle = {
            marginLeft: "auto"
        }
        return <div style={mainStyle}>
            <div style={{position: "absolute", left: "240px", bottom: "70px"}}>
                {this.props.canShow && this.popup}
            </div>
            <CurrencyCard icon={cash_icon} size={30} fontSize={20}
                          value={UtilsFunctions.toPrettyNumber(GameData.CurrentGame.cash)} style={currencyStyle}
                          title={"Наличные"}/>
            <CurrencyCard icon={debet_icon} size={30} fontSize={20}
                          value={UtilsFunctions.toPrettyNumber(GameData.CurrentGame.debet)} style={currencyStyle}
                          title={"Дебиторская задолженность"}/>
            <GameButtonWithIcon
                colorStart={"#8CED00"}
                colorEnd={"#66AE04"}
                icon={credit_icon}
                width={126}
                height={40}
                tooltip={"Кредиты и займы"}
                fontSize={20}
                iconWidth={30}
                onClick={() => {
                    this.popup = this.popup ? null : <CreditPopup
                        teamID={this.props.teamID}
                        onClose={() => {
                            this.popup = null;
                            this.props.updatePopup('credit');
                        }}/>

                    this.props.updatePopup('credit');
                    this.forceUpdate();
                }}
                title={UtilsFunctions.toPrettyNumber(GameData.CurrentGame.credit)} style={{
                paddingLeft: "20px"
            }}/>
            <CurrencyCard icon={creditors_icon} size={30} fontSize={20}
                          value={UtilsFunctions.toPrettyNumber(GameData.CurrentGame.creditors)}
                          title={"Кредиторская задолженность"} style={currencyStyle}/>
            <CurrencyCard icon={assets_icon} size={30} fontSize={20}
                          value={UtilsFunctions.toPrettyNumber(GameData.CurrentGame.fixedAssets)}
                          title={"Основные средства"} style={currencyStyle}/>
            <CurrencyCard icon={exp_icon} size={30} fontSize={20} value={GameData.CurrentGame.exp}
                          iconTitles={["Накопленный опыт угля", "Накопленный опыт остального"]} needsIcons={true}
                          title={"Накопленный опыт"} style={{...pushStyle}}/>
            <CurrencyCard icon={nsp_icon} size={30} fontSize={20} value={GameData.CurrentGame.nps}
                          iconTitles={["Индекс удовлетворённости клиентов по углю", "Индекс удовлетворённости клиентов по остальному"]}
                          needsIcons={true} title={"Индекс удовлетворённости клиентов"}/>
            <GameButtonWithIcon
                colorStart={"#FFCC33"}
                colorEnd={"#F2994A"}
                icon={statistic}
                tooltip={"Статистика"}
                width={40}
                height={40}
                style={{marginRight: "10px", padding: "5px"}}
                onClick={this.props.onStatisticsClick}
            />
            <GameButtonWithIcon
                colorStart={"#FFCC33"}
                colorEnd={"#F2994A"}
                icon={gainsLosses}
                tooltip={"Контракты"}
                width={40}
                height={40}
                style={{marginRight: "10px", padding: "5px"}}
                onClick={this.props.onContractsClick}
            />
            <GameButtonWithText title={"Заказы"} colorStart={"#FFCC33"} colorEnd={"#F2994A"} width={170} height={40}
                                fontSize={20} style={{
                marginRight: "30px"
            }} onClick={this.props.onOrdersClick}/>
        </div>;
    }
}
